import colors from 'loankeeper-common/components/colors'
import ErrorBoundary from 'loankeeper-common/components/ErrorBoundary'
import { LKTextArea } from 'loankeeper-common/components'

import { useUserConfig, useSystemConfig, withUserConfig, withSystemConfig } from './containers/withConfig'
import withLookups, { LookupType } from './containers/withLookups'
import withConstantPermissions, { usePermissions } from './containers/withConstantPermissions'
import withLivedata, { useLivedata } from './containers/withLivedata'

import { LocalLoader, DocumentTitle } from './Helpers'

import BrandedComponentLoader from './BrandedComponentLoader'

export * from './ApplicationSearch'
export * from './LKModal'

export {
  // container components
  withUserConfig,
  withSystemConfig,
  useUserConfig,
  useSystemConfig,
  withLookups,
  LookupType,
  withConstantPermissions,
  usePermissions,
  withLivedata,
  useLivedata,
  // Helpers
  LocalLoader,
  DocumentTitle,
  // auth components
  // others
  colors,
  ErrorBoundary,
  LKTextArea,
  BrandedComponentLoader,
}
